export default "__VITE_ASSET__Crs65drP__"